export default {
  usuarios: [],
  selectedUsuario: null,
  error: false,
  errorMessage: [],
}
